"use client";
const e = {
  search: "IoSearch",
  thumbsUp: "LuThumbsUp",
  thumbsDown: "LuThumbsDown",
  messageCopy: "LuCopy",
  messageCopied: "LuCheck",
  messageRevise: "FiEdit",
  codeCopy: "LuCopy",
  codeCopied: "LuCheck",
  openLinkInNewTab: "LuArrowUpRight",
  openLinkInSameTab: "LuCornerDownLeft",
  newLine: "LuCornerDownRight",
  breadcrumbSeparator: "FaChevronRight",
  switchToSearch: "IoSearch",
  switchToChat: "LuSparkles",
  chatSubmit: "IoSend",
  close: "IoCloseOutline",
  info: "IoInformationCircleOutline",
  command: "LuCommand"
};
export {
  e as defaultBuiltInIcons
};
